import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { InputColor } from '@dashboard/ui'

interface ThemeTokenControlProps {
  disabled?: boolean
  token: {
    path: string
    value: { value: string; $override?: boolean }
  }
  findToken: (token: string) => void
  onChange: (value: string) => void
}

export const ThemeTokenControl = ({ disabled, token, findToken, onChange }: ThemeTokenControlProps) => {
  const { t } = useTranslation('hub-theme')

  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.altKey) {
      findToken(token.path)
    }
  }

  return (
    <div className="flex flex-col gap-1" onClick={onClick}>
      <div className="flex items-center justify-between text-caption-md text-text-tertiary">
        <div>{t(`theme.tokens.${token.path}`, { defaultValue: token.path })}</div>
        {token.value.$override && (
          <div className="rounded bg-fg-brand-tertiary px-1 py-0.5 text-[10px] font-medium leading-[10px] text-text-brand-primary">
            {t('theme.overridden')}
          </div>
        )}
      </div>
      <InputColor
        options={{ alpha: true }}
        placeholder="Default value"
        disabled={disabled}
        value={token.value.value}
        onChange={onChange}
      />
    </div>
  )
}
